import { get, post } from '@/utils/https';

export const getAvailability = (params) => get('/api/app/v1/availability', params);
export const getMyAvailability = (params) => get('/api/app/v1/availability/me', params);
export const saveAvailability = (data) => post('/api/app/v1/availability', data);
export const remindAvailability = (data) => post('/api/app/v1/availability/remind', data);

export default {
  getAvailability,
  getMyAvailability,
  saveAvailability,
  remindAvailability,
};

